//Users
export const ADD_ALERT = "ADD_ALERT";
export const ALL_ALERTS = "ALL_ALERTS";
export const DELETE_ALERTS = "DELETE_ALERTS";
export const SIGN_IN = "SIGN_IN";
export const LOG_OUT = "LOG_OUT";
export const RESET = "RESET";
export const VIEW_CERT = "VIEW_CERT";

// CarDetails
export const ADD_CAR_DETAIL = 'ADD_CAR_DETAIL';
export const FETCH_ALL_CAR_DETAILS = 'FETCH_ALL_CAR_DETAILS';
export const UPDATE_CAR_DETAIL = 'UPDATE_CAR_DETAIL';
export const DELETE_CAR = 'DELETE_CAR';
export const SEARCH_CARS = 'SEARCH_CARS';

// Accounts
export const FETCH_ALL_ACCOUNTS = 'FETCH_ALL_ACCOUNTS';
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO';
export const ACCOUNT_DROPDOWN = 'ACCOUNT_DROPDOWN'; 

//Agreement
export const CREATE_AGREEMENT = 'CREATE_AGREEMENT'; 
export const FETCH_ALL_AGREEMENT = 'FETCH_ALL_AGREEMENT';
export const UPDATE_AGREEMENT = 'UPDATE_AGREEMENT';
export const DELETE_AGREEMENT = 'DELETE_AGREEMENT';
export const ADD_AGREEMENT_TO_CARDETAIL = 'ADD_AGREEMENT_TO_CARDETAIL';
export const SEARCH_AGREEMENTS = 'SEARCH_AGREEMENTS';

//Proforma Invoice
export const CREATE_PROFORMA_INVOICE = 'CREATE_PROFORMA_INVOICE';
export const FETCH_ALL_PROFORMA_INVOICES = 'FETCH_ALL_PROFORMA_INVOICES';
export const FETCH_INVOICE_PATH = 'FETCH_INVOICE_PATH';
export const DELETE_PROFORMA_INVOICE = 'DELETE_PROFORMA_INVOICE';
export const ADD_PROFORMA_INVOICE_TO_CARDETAIL = 'ADD_PROFORMA_INVOICE_TO_CARDETAIL';

//Final Invoices
export const FETCH_ALL_FINAL_INVOICES = 'FETCH_ALL_FINAL_INVOICES';
export const DELETE_FINAL_INVOICE = 'DELETE_FINAL_INVOICE';

// Re Processing Form
export const CREATE_RE_PROCESSING = 'CREATE_RE_PROCESSING';
export const FETCH_ALL_REPROCESSING = 'FETCH_ALL_REPROCESSING';
export const DELETE_REPROCESSING = 'DELETE_REPROCESSING';
export const ADD_REPROCESSING_TO_CARDETAIL = 'ADD_REPROCESSING_TO_CARDETAIL';


//installments
export const INSTALLMENT_LIST = 'INSTALLMENT_LIST';
export const CREATE_INSTALLMENT = 'CREATE_INSTALLMENT';
export const ADD_INSTALLMENT_TO_AGREEMENT = 'ADD_INSTALLMENT_TO_AGREEMENT';
export const DELETE_INSTALLMENT = 'DELETE_INSTALLMENT';
export const UPDATE_INSTALLMENT_PLAN = 'UPDATE_INSTALLMENT_PLAN';
export const CREATE_INSTALLMENT_SCHEDULE = 'CREATE_INSTALLMENT_SCHEDULE';

